export default __webpack_public_path__ + "static/media/1.5b134b48.jpg";